import  axios  from '@/assets/js/axios'
const api = {
  announcement:"/bid_news/official_account/announcement/list",
  oauth:"/bid_news/oauth",//静默授权
  // login:"/bid_news/official_account/login",//登录
  login:"/bid_news/register",//绑定手机号
  // sms:"/bid_news/official_account/sms",//验证码
  sms:"/bid_news/official_account/sms",//验证码
  report:"/bid_news/official_account/report/newest_info",//验证码
  collectCount:"bid_news/official_account/collection/upload_count",//收藏导出数量
  collectUpload:"/bid_news/official_account/collection/upload",//收藏导出
  checklogin:"/bid_news/official_account/checklogin",//收藏导出

}
export default api

// 首页
export function getAnnouncement (parameter) {
  return axios({
    url: api.announcement,
    method: "post",
    data: parameter
  });
}
export function getOauth (parameter) {
  return axios({
    url: api.oauth,
    method: 'post',
    data: parameter
  })
}
export function toLogin (parameter) {
  return axios({
    url: api.login,
    method: 'post',
    data: parameter
  })
}
export function getSms (parameter) {
  return axios({
    url: api.sms,
    method: 'post',
    data: parameter
  })
}
export function getReport (parameter) {
  return axios({
    url: api.report,
    method: 'post',
    data: parameter
  })
}
export function getCollectCount (parameter) {
  return axios({
    url: api.collectCount,
    method: 'post',
    data: parameter
  })
}
export function getCollectUpload (parameter) {
  return axios({
    url: api.collectUpload,
    method: 'post',
    data: parameter
  })
}
export function checklogin (parameter) {
  return axios({
    url: api.checklogin,
    method: 'post',
    data: parameter
  })
}


